import React, { useEffect, useRef, useState } from "react";
import RightToolbar from "./../components/RightToolbar";
import Sidebar from "./../components/Sidebar";
import { mailMessages2 } from "./../utils/mails2";

function Mail2() {
  const [chechedAll, setCheckedAll] = useState(false);
  const [mails, setMails] = useState([]);
  const [previewMail, setPreviewMail] = useState(null);
  const [showReply, setShowReply] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replies, setReplies] = useState({});

  const replyRef = useRef(null);
  const stefanShownRef = useRef(false);

  useEffect(() => {
    if (showReply) replyRef.current?.focus();
  }, [showReply]);

  const handleSend = (id) => {
    if (!replyText.trim()) return;

    setReplies((prev) => ({
      ...prev,
      [id]: [...(prev[id] || []), replyText],
    }));

    setReplyText("");
    setShowReply(false);
  };

  useEffect(() => {
    const allMails = mailMessages2.map((mail, index) => ({
      ...mail,
      id: index + 1,
      cheched: false,
      starred: false,
    }));
    setMails(allMails);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Enter") return;
      if (stefanShownRef.current) return;
      if (previewMail !== null) return;

      e.preventDefault();
      stefanShownRef.current = true;

      setMails((prev) => {
        const maxId = prev.reduce((m, x) => Math.max(m, x.id), 0);
        return [
          {
            id: maxId + 1,
            cheched: false,
            starred: false,
            title: "Stefan | Holy Code · stefan.nenadovic@holycode.com",
            snippet:
              "Jane, ti ćeš mi trebati malo duže, tako da ostani posle sastanka. Nešto moram da prođem s tobom. Stefan",
            time: "11:02 AM",
            isNew: true,
          },
          ...prev,
        ];
      });
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [previewMail]);

  const checkAllMails = () => {
    setCheckedAll((prev) => !prev);
    setMails((curr) =>
      curr.map((mail) => ({
        ...mail,
        cheched: !chechedAll,
      }))
    );
  };

  const checkMail = (id) => {
    setMails((curr) =>
      curr.map((mail) => ({
        ...mail,
        cheched: mail.id === id ? !mail.cheched : mail.cheched,
      }))
    );
  };

  const starMail = (id) => {
    setMails((curr) =>
      curr.map((mail) => ({
        ...mail,
        starred: mail.id === id ? !mail.starred : mail.starred,
      }))
    );
  };

  const deleteCheckedMails = () => {
    setCheckedAll(false);
    setMails((curr) => curr.filter((mail) => !mail.cheched));
  };

  const deleteMail = (id) => {
    setPreviewMail(null);
    setMails((curr) => curr.filter((mail) => mail.id !== id));
  };

  const selectMailForPreview = (id) => {
    setCheckedAll(false);
    setPreviewMail(id);
    setMails((curr) =>
      curr.map((mail) => ({
        ...mail,
        cheched: false,
      }))
    );
  };

  const MessageRow = ({
    cheched,
    id,
    title,
    time,
    snippet,
    starred,
    isNew,
  }) => {
    return (
      <div className={`mail-msg-row ${isNew ? "new-mail" : ""}`}>
        <span
          className="material-symbols-outlined mail-pointer"
          onClick={() => checkMail(id)}
        >
          {cheched ? "check_box" : "check_box_outline_blank"}
        </span>

        <div className="mail-star">
          <span
            className={`material-icons${
              !starred ? "" : "-outlined"
            } mail-pointer`}
            onClick={() => starMail(id)}
          >
            {starred ? "mail-star" : "star_outline"}
          </span>
        </div>

        <div
          className="mail-snippet mail-pointer"
          onClick={() => selectMailForPreview(id)}
        >
          {title}
        </div>
        <div
          className="mail-snippet mail-pointer"
          onClick={() => selectMailForPreview(id)}
        >
          {snippet}
        </div>
        <div className="time">{time}</div>
      </div>
    );
  };

  const renderMail = () => {
    const sel = mails.find((mail) => mail.id === previewMail);
    if (!sel) return null;
    const { snippet, title } = sel;

    return (
      <div className="render-mail">
        <span
          className="material-symbols-outlined mail-pointer"
          onClick={() => selectMailForPreview(null)}
        >
          arrow_back
        </span>
        <span
          className="material-symbols-outlined delete mail-pointer"
          onClick={() => deleteMail(previewMail)}
        >
          delete
        </span>
        <span
          className="material-symbols-outlined mail-pointer"
          onClick={() => setShowReply((s) => !s)}
        >
          reply
        </span>

        <h1>{title}</h1>
        <p>{snippet}</p>
        {replies[previewMail] && (
          <div className="replies">
            {replies[previewMail].map((r, i) => (
              <div key={i} className="reply-msg">
                <div className="reply-author">You:</div>
                <div className="reply-text">{r}</div>
              </div>
            ))}
          </div>
        )}

        {showReply && (
          <div className="reply-box">
            <textarea
              ref={replyRef}
              className="reply-textarea"
              placeholder="Write your reply…"
              value={replyText}
              onChange={(e) => setReplyText(e.target.value)}
              rows={5}
            />
            <div className="reply-actions">
              <button
                className="btn send"
                onClick={() => handleSend(previewMail)}
                disabled={!replyText.trim()}
              >
                Send
              </button>
              <button
                className="btn cancel"
                onClick={() => {
                  setShowReply(false);
                  setReplyText("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const isAnyMailChecked = () => mails.some((mail) => mail.cheched);

  return (
    <div className="page-mail-bg">
      <div className="mail-window">
        <div className="mail-window-header">
          <div className="mail-header-left">
            <div className="mail-search-box">
              <span className="material-icons-outlined">search</span>
              <input type="text" placeholder="Search mail" />
            </div>
            <div className="mail-title">Mail</div>
          </div>

          <div className="mail-header-right">
            <span className="material-icons-outlined">menu</span>
            <span className="material-icons-outlined">star</span>
            <div className="mail-profile"></div>
          </div>
        </div>

        <div className="mail-window-body">
          <Sidebar />

          <main className="mail-main-panel">
            {previewMail ? (
              <div className="mail-preview-mail">{renderMail(previewMail)}</div>
            ) : (
              <>
                <div className="mail-data">
                  <span
                    className="material-symbols-outlined mail-pointer"
                    onClick={() => (mails.length ? checkAllMails() : {})}
                  >
                    {chechedAll ? "check_box" : "check_box_outline_blank"}
                  </span>

                  {isAnyMailChecked() && (
                    <span
                      className="material-symbols-outlined mail-pointer"
                      onClick={deleteCheckedMails}
                    >
                      delete
                    </span>
                  )}

                  <span className="material-symbols-outlined">more_horiz</span>

                  <div className="mail-count">
                    {mails.length > 0 ? 1 : 0} - {mails.length} of{" "}
                    {mails.length}
                    <span className="material-symbols-outlined mail-pointer">
                      keyboard_arrow_left
                    </span>
                    <span className="material-symbols-outlined mail-pointer">
                      keyboard_arrow_right
                    </span>
                  </div>
                </div>

                <div className="mail-tabs-row">
                  <span className="material-icons-outlined mail-icon">
                    inbox
                  </span>
                  Primary
                  <span className="material-icons-outlined mail-icon">
                    person
                  </span>
                  Social
                  <span className="material-icons-outlined mail-icon">
                    sell
                  </span>
                  Promotions
                </div>

                <div className="mail-messages-list">
                  {mails.map((row) => {
                    const {
                      cheched,
                      id,
                      time,
                      title,
                      snippet,
                      starred,
                      isNew,
                    } = row;
                    return (
                      <MessageRow
                        cheched={cheched}
                        id={id}
                        key={id}
                        title={title}
                        snippet={snippet}
                        time={time}
                        starred={starred}
                        isNew={isNew}
                      />
                    );
                  })}
                </div>
              </>
            )}
          </main>

          <RightToolbar />
        </div>
      </div>
    </div>
  );
}

export default Mail2;
